<template>
    <div v-if="bedTypes.length" class="d-flex align-center">
        <template v-for="(bed, index) in bedTypes">
            <div v-if="bed.nameToken !== 'undefined'" :key="index" class="d-flex">
                <span v-if="index !== 0" class="px-2 text-caption">
                    {{ bed.alternate || bed.alternative ? $t('or') : $t('and') }}
                </span>
                <v-icon start>{{ getIcon(bed.nameToken) }}</v-icon>
                <span class="text-caption me-1">{{ bed.quantity }}</span>
                <span v-if="bed.nameToken" class="text-caption">{{ getType(bed.nameToken, bed.quantity) }}</span>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component({})
    export class HotelBedTypeLabel extends Vue {
        @Prop({required: true}) bedTypes

        getIcon(token) {
            switch (token) {
                case 'double_bed':
                    return 'mdi-bed-king-outline'
                case 'full_bed':
                    return 'mdi-bed-king-outline'
                case 'king_bed':
                    return 'mdi-bed-king-outline'
                case 'queen_bed':
                    return 'mdi-bed-king-outline'
                case 'twin_bed':
                    return 'mdi-bed-single-outline'
                case 'single_bed':
                    return 'mdi-bed-single-outline'
                case 'sofa_bed_double':
                    return 'mdi-sofa-outline'
                case 'sofa_bed_king':
                    return 'mdi-sofa-outline'
                case 'sofa_bed_queen':
                    return 'mdi-sofa-outline'
                case 'sofa_bed_twin':
                    return 'mdi-sofa-single-outline'
                case 'sofa_bed_single':
                    return 'mdi-sofa-single-outline'
            }
        }

        getType(token, quantity) {
            return this.$t(`bed_types.${token}`, quantity)
        }
    }

    export default HotelBedTypeLabel
</script>
